// src/components/dashboard/cases/newCase/case_id/caseTable/constants.js
import * as THREE from "three";

export const SMOOTH_VERTEX_LIMIT = 1500000;
export const HEAVY_TRIANGLE_COUNT = 200000;

export const ROTATE_SPEED = 1.5;
export const ZOOM_SPEED = 0.9;
export const PAN_FEEL = 1.0;
export const DAMPING = 0.2;

export const INITIAL_FIT_FACTOR = 2.0;

export const PAN_EDGE_FACTOR = 1.0;
export const MAX_ZOOM_OUT_FACTOR = 2.5;
export const ZOOM_OUT_BASE_FACTOR = 3.2;

export const OPACITY_MIN = 5;
export const OPACITY_MAX = 100;

export const CLIP_PLANE_SIZE_MULT_DEFAULT = 0.85;
export const CLIP_PLANE_SIZE_MULT_MIN = 0.05;
export const CLIP_PLANE_SIZE_MULT_MAX = 4.0;
export const CLIP_PLANE_COLOR = 0x66ccee;
export const CLIP_PLANE_EDGE = 0x2244cc;
export const CLIP_PLANE_EDGE_INVERTED = 0xf5c518;
export const CLIP_PLANE_OPACITY = 0.42;
export const CLIP_OFFSET_RANGE = 1.0;
export const CLIP_HANDLE_RED = 0xe53935;
export const CLIP_HANDLE_BLUE = 0x1e88e5;
export const CLIP_HANDLE_GREEN = 0x43a047;
export const CLIP_HANDLE_PURPLE = 0x8e24aa;
export const CLIP_ARROW_COLOR = 0x555555;
export const CLIP_OUTLINE_COLOR = 0x1faa3c;
export const CLIP_MAX_SEGMENTS = 400000;

export const MEASURE_COLOR = 0x2196f3;
export const MEASURE_ACCENT = 0x64b5f6;
export const MEASURE_HALO_COLOR = 0xffffff;
export const MEASURE_HALO_PX = 1.2;
export const MEASURE_UNIT = "mm";
export const MEASURE_DECIMALS = 3;
export const formatMm = (v) => v.toFixed(MEASURE_DECIMALS);
export const MEASURE_TUBE_PX = 1.0;
export const MEASURE_CONE_RADIUS_PX = 4.5;
export const MEASURE_CONE_LENGTH_PX = 14;
export const MEASURE_DOT_PX = 3.0;
export const MEASURE_HIT_PX = 16;

export const DRAW_LINE_COLOR = 0xff2222;
export const DRAW_LINE_HALO_COLOR = 0xffffff;
export const DRAW_LINE_PX = 2.2;
export const DRAW_LINE_HALO_PX = 1.6;
export const DRAW_DOT_PX = 6;
export const DRAW_DOT_HALO_PX = 1.6;

export const XS_MEASURE_LINE_COLOR = "#e0e0e0";
export const XS_MEASURE_LINE_HALO = "rgba(0, 0, 0, 0.85)";
export const XS_MEASURE_POINT_RADIUS = 4;
export const XS_MEASURE_HIT_RADIUS = 10;
export const XS_MEASURE_LINE_WIDTH = 2;
export const XS_SNAP_RADIUS_PX = 14;
export const XS_SNAP_VERTEX_PX = 9;
export const XS_MEASURE_LABEL_COLOR = "#e0e0e0";
export const XS_MEASURE_LABEL_HALO = "rgba(0, 0, 0, 0.9)";

export const MULTI_MODEL_COLORS = [
  0xe8e8e8, 0x4fc3f7, 0xffb74d, 0x81c784, 0xe57373,
  0xba68c8, 0xfff176, 0x4db6ac, 0xf06292, 0x9575cd,
];

export const MULTI_MODEL_GAP_FACTOR = 0.15;
export const CONNECT_SHARED_SPACE_MODELS = true;
export const CONNECT_TOLERANCE_FACTOR = 0.02;
export const CONNECT_MIN_SPREAD_FACTOR = 0.05;

export const MODEL_SELECTED_BASE_COLOR = 0xbfd6f0;
export const MODEL_SELECTED_EMISSIVE = 0x2a6bb8;
export const MODEL_SELECTED_EMISSIVE_INTENSITY = 0.35;
export const MODEL_SELECTED_METALNESS = 0.35;
export const MODEL_SELECTED_ROUGHNESS = 0.45;
export const MODEL_ROTATE_SPEED = 0.01;

export const DEFAULT_MODEL_STATE = {
  visible: true,
  opacity: OPACITY_MAX,
  detached: false,
};

export const ROT_HANDLES = [
  { id: "rotX", axis: [1, 0, 0], radial: [0, 1, 0] },
  { id: "rotY", axis: [0, 1, 0], radial: [1, 0, 0] },
  { id: "rotZ", axis: [0, 0, 1], radial: [-0.7071, -0.7071, 0] },
];

export const VIEW_DIRECTIONS = {
  default: new THREE.Vector3(0, 1, 0.35),
  front:   new THREE.Vector3(0, 0, 1),
  rear:    new THREE.Vector3(0, 0, -1),
  left:    new THREE.Vector3(-1, 0, 0),
  right:   new THREE.Vector3(1, 0, 0),
  top:     new THREE.Vector3(0, 1, 0.001),
  bottom:  new THREE.Vector3(0, -1, -0.001),
};